export default {
  firstMethod: 'У меня есть объект, я хотел бы',
  infoPropMethod: 'Мне нужно получить',
  methodOptions: 'Мне нужно',
  methodTypes: {
    create: 'создать',
    determine: 'определить',
    'return a': 'вернуть',
    'find out': 'узнать',
    'get an array of all of the': 'получить массив всех'
    // string: 'string'
  },
  details: 'информацию о свойстве',
  list: 'список всех ключей и/или значений',
  primaryOptions: [
    'создать объект',
    'создать свойство',
    'получить информацию об объекте',
    'получить информацию о свойстве',
    'ограничить возможность изменения объекта',
    'сформировать строку из объекта',
    'управлять поведением прототипов'
  ]
  // other text can be added here
}



// WEBPACK FOOTER //
// ./src/locale/ru/index.js